import {ZoneItem} from "../../protobuf/zone_service_pb";
import {ServiceCentresState} from "../../types";

export function parseMaintenanceServicesList(list?: ServiceCentresState["maintenanceServicesList"]) {
    if (list) {
        return list.map((service) => ({
            label: service.name,
            value: service.name,
        }));
    }

    return [];
}